import React from "react";
import style from './success-view.module.scss'
import { PaywallTranslations } from "../paywall-comp";
import { getMobileOperatingSystem } from "../../../../../javascript/utils";
import { Typography } from "../../../../react/components/typography/typography";
import { Button } from "../../../../react/components/button/button";
import { SuccessCheckmark } from "../../../../react/vectors/success_checkmark";

interface Props {
  close: (event) => void;
  translations: PaywallTranslations;
}

export default function SuccessView (props: Props) {
  const system = getMobileOperatingSystem();
  const showAndroid = system == 'android' || system == null;
  const showIOS = system == 'ios' || system == null;
  const asLinks = system != null;

  return (
    <div className={style.container}>
      <SuccessCheckmark />
      <Typography
        themeColor="text-ink-main"
        textSize="sys-display-small"
        element="div"
        style={{textAlign: 'center', marginTop: '16px'}}
      >
        {props.translations['lokalise.catalog.article_paywall.modal.your_offer_was_activated']}
      </Typography>

      <Button
        buttonSize="large"
        buttonStyle="primary"
        element="button"
        theme="light"
        className={style.button}
        onClick={props.close}
        id="paywall-modal-success-view-finish-reading-button"
      >
        {props.translations['lokalise.catalog.article_paywall.modal.finish_reading']}
      </Button>

      <Typography
        textColor="sys-light-ink-main"
        textSize="sys-title-medium"
        element="div"
        style={{textAlign: 'center', marginTop: '16px'}}
      >
        {props.translations['lokalise.catalog.article_paywall.enjoy_best_reading_experience']}
      </Typography>

      <div className={style.storeContainer}>
        {showIOS ?
        <a href={asLinks ? props.translations['app_store_link'] : null}>
          <img src="https://dnjpbxg2wcpr8.cloudfront.net/web/images/app_store_on_dark.svg" />
        </a>
        :null}
        {showAndroid ?
        <a href={asLinks ? props.translations['google_play_link'] : null}>
          <img src="https://dnjpbxg2wcpr8.cloudfront.net/web/images/google_play_store_on_dark.svg" style={{ marginLeft: '8px' }} />
        </a>
        :null}
      </div>
    </div>
  )
}